export default __webpack_public_path__ + "static/media/asset-icon.7dfa8dbe.svg";